import { getImportOptionsFormStyle } from '@bingads-webui-campaign-react/imports-shared-styles';

const getGlobalCommonStyle = ({ palette = {} }) => ({
  '& .import-steps': {
    maxWidth: 1020,
    marginTop: 32,

    '& .step-container': {
      marginBottom: 24,
    },
    '& .step-header': {
      borderBottom: '1px solid #a2a2a2',

      '& h3': {
        fontSize: 14,
        marginTop: 0,
        fontWeight: 400,

        '& span': {
          verticalAlign: 'middle',
        },
        '& span.summary-section': {
          display: 'inline-block',
          color: '#A2A2A2',
          maxWidth: 600,
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          lineHeight: 1.4,
        },
        '& a': {
          verticalAlign: 'middle',
        },
      },

      '& .edit-step.glyphicon-pencil': {
        float: 'none!important',
        marginLeft: 8,
      },
    },

    '& .step-body': {
      marginLeft: 7.5,
    },

    '& .step-footer': {
      marginLeft: 7.5,

      '& .btn + .btn': {
        marginLeft: 8,
      },
    },

    '& .step-content': {
      paddingTop: 15,
      maxWidth: 1020,

      '& h3': {
        fontSize: 14,
        fontWeight: 600,
      },

      '& .export-errors': {
        textDecoration: 'underline',
      },
    },

    '& .step-header[data-step-status="done"] h3': {
      display: 'inline-block',
    },

    '& .step-header[data-step-status="active"] h3': {
      fontWeight: 600,
    },

    '& [data-step-status="pending"]': {
      color: '#cccccc',
    },

    '& .form-group': {
      maxWidth: 900,

      '& .control-label, .summary-info': {
        paddingTop: 4,
      },
    },

    '& .error': {
      color: '#A80000',
      margin: '5px 0',
    },

    '& .iconba': {
      position: 'static',
      marginRight: 5,
    },

    '& .iconba-Warning': {
      color: '#D83B01',
    },

    '& .iconba-ErrorBadge': {
      color: '#A80000',
    },

    '& .bingadsgrid .table-container colgroup.column-group .col-Name': {
      width: 300,
      minWidth: 300,
    },

    '& .bingadsgrid .table-container colgroup.column-group .col-Errors': {
      width: 140,
      minWidth: 140,
    },

    '& .table-bordered': {
      border: 0,
    },
  },

  '& .import-page-title': {
    '& h1': {
      fontSize: 20,
      lineHeight: '27px',
    },
    '& .page-title-subheader': {
      fontSize: 14,
      lineHeight: '24px',
      fontWeight: 'normal',
      marginTop: 30,
      marginBottom: 0,
    },
  },

  '& #importPage': {
    '& .section': {
      paddingBottom: 10,
      overflow: 'hidden',
    },

    '& .disabled-section': {
      color: '#cccccc',
    },

    '& .btn + .btn': {
      marginLeft: 8,
    },
  },

  // import options
  ...getImportOptionsFormStyle({ palette }),

  '& [data-step-name="import-options-step"] .import-options-indented-section': {
    paddingLeft: '28px',
  },
  '& .schedule-import-step .error': {
    color: '#A80000',
    margin: '5px 0',
  },

  // import summary
  '& .step-body[data-step-name="import-summary-step"]': {
    '& .form-horizontal': {
      '& .col-sm-2.control-label': {
        textAlign: 'left',
        width: '100%',
      },

      '& .col-sm-4.summary-info': {
        float: 'unset',
        width: '100%',
      },
    },

    '& .import-summary-grid': {
      width: 900,
      marginTop: 25,
      marginBottom: 20,
      minHeight: 0,
      backgroundColor: '#e5e5e5',
      borderBottomColor: '#ddd',
      borderBottomStyle: 'solid',
      borderBottomWidth: '1px',

      '& .viewport': {
        maxHeight: 420,
        overflow: 'auto',
        backgroundColor: '#ffffff',

        '@media screen and (max-height: 1000px)': {
          maxHeight: 300,
        },

        '@media screen and (max-height: 900px)': {
          maxHeight: 120,
        },
      },

      '& .fixed-header': {
        backgroundColor: '#ffffff',
      },

      '& .fixed-height .viewport': {
        height: 420,
      },

      '& .expanded-margin': {
        marginLeft: 15,
      },

      '& .table.table-bordered': {
        '& .header tr': {
          '& th': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
          '& th[data-name="Name"]': {
            padding: '8px 10px',
            borderRight: `1px solid ${palette.neutralLight}`,
          },

          '& th[data-name="Additions"]': {
            borderRight: `1px solid ${palette.neutralLight}`,
          },
        },

        '& tbody tr': {
          '& .truncated': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            padding: '8px 10px',
            borderRight: `1px solid ${palette.neutralLight}`,
          },

          '& td:nth-child(2)': {
            borderRight: `1px solid ${palette.neutralLight}`,
          },
        },

        '& .spritedimagealign': {
          paddingRight: 5,
        },
      },
    },

    '& .import-summary-grid + .form-group': {
      '& >.HelpTopic': {
        paddingLeft: 5,
      },
    },
  },
});

export const importUiBlockerStyle = ({ palette = {} }, iconFontFamily = 'MsAds MDL2 Assets') => ({
  '.blocker-container': {
    '& .blocker-indicator': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '0 0 12px 0',

      '& .blocker-image': {
        position: 'absolute',
        top: 10,
        left: 10,
      },

      '& .blocker-text': {
        margin: '12px 0 0 50px',

        '& .import-blocker': {
          color: palette.neutralPrimary,
          maxWidth: 400,
          margin: '-12px 0 -12px -50px',
          padding: 10,
          boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',

          '& >span': {
            fontWeight: 600,
            paddingLeft: 40,
            verticalAlign: 'middle',
          },

          '& .blocker-subtext': {
            marginTop: 10,

            '& .indicator-steps-panel': {
              marginTop: 19,

              '& >ul': {
                listStyle: 'none',
                paddingLeft: 0,

                '& .indicator': {
                  marginBottom: 10,

                  '& .error-class': {
                    fontFamily: iconFontFamily,
                    fontSize: 14,
                    display: 'inline-block',
                    marginRight: 12,
                    verticalAlign: 'middle',
                    width: 14,
                    height: 14,
                    lineHeight: '14px',
                    color: palette.themePrimary,
                  },

                  '& .indicator-done:before': {
                    content: '"\\EC61"',
                  },

                  '& .indicator-done + span': {
                    fontWeight: 600,
                  },

                  '& .error-class + span': {
                    verticalAlign: 'middle',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
});

const pageContainerTop = 24;
const pageContainerLeft = 32;

export const getCommonStyle = ({ palette = {} }) => ({
  pageContainer: {
    marginTop: pageContainerTop,
    marginLeft: pageContainerLeft,
    marginBottom: 32,

    '& .fac-banner-positioning-container': {
      marginTop: -pageContainerTop,
      marginLeft: -pageContainerLeft,
    },

    ...getGlobalCommonStyle({ palette }),
  },
});
